/*
 *  Copyright (c) Qwoach LLC 2021. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 1/12/2021
 */
import FormElementType from "@/core/modules/coach/Resources/Forms/model/FormElements/FormElementType";
import BaseSmartFormElement from "@/core/modules/coach/Resources/Forms/model/FormElements/Smart/BaseSmartFormElement";

export default class FormElementFullName extends BaseSmartFormElement {


	constructor(title, options = {}) {
		super(FormElementType.FULL_NAME, title, {required: true, ...options});
	}

	resetElement() {
		super.resetElement();
		this.title = "Full Name"
		this.isRequired = true
		this.showRequiredSwitch = false
		this.placeholder = "Full Name Question Text"
		// this.disableEditing = true
		// this.specialQuestionDescription = "full name"
	}

	getSpecialQuestionDescription(){
		return "full name"
	}

	getSmartFiledPropertyName(){
		return "name"
	}


}
